import { render } from "./ConsentLayout.vue?vue&type=template&id=43149c66"
import script from "./ConsentLayout.vue?vue&type=script&lang=js"
export * from "./ConsentLayout.vue?vue&type=script&lang=js"

import "./ConsentLayout.vue?vue&type=style&index=0&id=43149c66&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__